/**
 * 반응형 브레이크포인트 미디어 쿼리\
 * 고향사랑기부 PC 버전 업데이트를 위해 정의된 break-point 값\
 * image의 sizes와 useMediaQuery와 함께 사용
 */
export const BREAKPOINTS = {
  MOBILE: '(max-width: 850px)',
  TABLET: '(min-width: 851px) and (max-width: 1279px)',
  MOBILE_TABLET: '(max-width: 1279px)',
  DESKTOP: '(min-width: 1280px)',
} as const;
